import FormDropdown from "@components/Form/FormDropdown";
import FormInput from "@components/Form/FormInput";
import FormLabel from "@components/Form/FormLabel";
import FormRadio from "@components/Form/FormRadio";
import { StyledXSmall } from "@components/Styled/Text";
import React from "react";
import { clsx } from "clsx";
import { withFitFeedback } from "./withFitFeedback";

const FitWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "flex w-full flex-col px-zero md:px-mini")}
  />
);

const Fit = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "mb-midi flex flex-col md:flex-row md:items-center",
      "[&_label]:pb-zero",
    )}
  />
);

const FitHeading = (props: any) => (
  <FormLabel
    {...props}
    className={clsx(
      props.className,
      "[&_label]:text-h5 [&_label]:tracking-[1.2px] [&_label]:opacity-50",
    )}
  />
);

const FitLabel = FormLabel;

const FitOptionWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "md:w-4/6 flex justify-between md:ml-midi",
    )}
  />
);

const FitOption = FormRadio;

const SizeDropdown = (props: any) => (
  <FormDropdown
    {...props}
    className={clsx(
      props.className,
      props.error &&
        "mb-zero [&_input]:border-b-2 [&_input]:border-warning [&_input]:text-warning",
    )}
  />
);

const SizeSelectorWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "mb-midi flex w-full flex-col px-zero md:w-1/2 md:px-mini",
    )}
  />
);

const ReviewTitle = (props: any) => (
  <FormInput
    {...props}
    className={clsx(
      props.className,
      "mb-midi w-full px-zero md:w-1/2 md:px-mini [&_input]:h-maxi",
    )}
  />
);

const ErrorMessage = (props: any) => (
  <StyledXSmall
    {...props}
    className={clsx(props.className, "text-orange mb-mini mt-pico")}
  />
);

const FitFeedback = withFitFeedback(
  ({
    errors,
    fitLength,
    fitWidth,
    gender,
    handleFitWidthChange,
    handleFitLengthChange,
    handleSizeChange,
    handleTitleChange,
    sizeOptions,
    shoeFitLength,
    shoeFitWidth,
    title,
  }) => {
    return (
      <>
        <FitWrapper>
          <FitHeading
            id="fit-heading"
            label="HOW DID YOU FIND THE FIT?"
            required={false}
          />
          <Fit>
            <FitLabel id="fit-length" label="Shoe Length" required />
            <FitOptionWrapper>
              {shoeFitLength?.map(({ value, label }) => {
                return (
                  <FitOption
                    key={label}
                    dataTestId={label}
                    name={value}
                    label={label}
                    value={fitLength === value}
                    handleChange={handleFitLengthChange}
                    internalState
                  />
                );
              })}
            </FitOptionWrapper>
          </Fit>

          <Fit>
            <FitLabel id="fit-width" label="Shoe Width" required />
            <FitOptionWrapper>
              {shoeFitWidth?.map(({ value, label }) => {
                return (
                  <FitOption
                    key={label}
                    dataTestId={label}
                    name={value}
                    label={label}
                    value={fitWidth === value}
                    handleChange={handleFitWidthChange}
                    internalState
                  />
                );
              })}
            </FitOptionWrapper>
          </Fit>
        </FitWrapper>
        <SizeSelectorWrapper>
          <FitLabel
            id="size-selector"
            label="What is your usual shoe size?"
            required
          />
          <SizeDropdown
            dataTestId={`${gender}-sizes`}
            placeholder="Select a size"
            layout="form"
            options={sizeOptions}
            handleChange={handleSizeChange}
            error={!!errors["size"]}
          />
          {errors["size"] ? (
            <ErrorMessage>{errors["size"]}</ErrorMessage>
          ) : null}
        </SizeSelectorWrapper>
        <ReviewTitle
          data-testid="review-title"
          name="title"
          label="Review Title"
          width="1/2"
          value={title}
          handleChange={handleTitleChange}
        />
      </>
    );
  },
);

export default FitFeedback;
